@if (emailOnlyError) {
    @if (userRole === Role.Station_Manager) {
        @if (selectedInboxTab !== null) {
            <app-tabs
                [tabs]="tabsData"
                [initialSelectedTabIndex]="selectedInboxTabIndex"
                (tabSelected)="onTabChanged($event)" />
        }
    }
    <div class="p-6">
        @if (userRole === Role.Fixer) {
            <div class="text-md text-semi mb-2">
                You cannot access any data because the station(s) you are
                associated with is configured to work with email only.
            </div>
            <div class="text-md text-light">
                Please reach out to your organization's Workflow administrator
                or your Station Manager for more information.
            </div>
        } @else if (userRole === Role.Station_Manager) {
            <div class="text-md text-semi mb-2">
                You cannot access any data for station(s) configured to work
                with email only.
            </div>
            <div class="text-md text-light">
                Please reach out to your Workflow account administrator for more
                information.
            </div>
        }
    </div>
} @else {
    @if (showWorkflowInstanceSelector) {
        <div class="instance-select">
            <div class="instance-select__wrapper">
                <app-select
                    label="Workflow Instance"
                    placeholder="Select Instance"
                    [dataQa]="dataQa.stationInboxWorkflowInstanceSelect"
                    [options]="workflowInstanceOptions"
                    [value]="selectedWorkflow"
                    (selectionChange)="onWorkflowInstanceChange($event)" />
            </div>
        </div>
    }
    @if (workflowSelectionRequired) {
        <span class="workflow-selection-message color-gray12">
            Please select a workflow instance to display inbox items.
        </span>
    } @else {
        <div>
            @if (selectedInboxTab !== null) {
                <app-tabs
                    [tabs]="tabsData"
                    [initialSelectedTabIndex]="selectedInboxTabIndex"
                    (tabSelected)="onTabChanged($event)" />
            }
            <div class="flex justify-space-between items-center">
                <ng-container *ngTemplateOutlet="countTemplate" />
                <div class="flex items-center">
                    <app-refresh-inbox
                        [lastSyncDate]="lastSyncDate"
                        [dataQa]="dataQa.stationInboxRefreshButton"
                        (clicked)="refreshInbox()" />
                    <span class="divider mr-2 ml-2"></span>
                    <app-table-view-menu
                        [selected]="selectedTableView"
                        [docOptions]="docViewColumnOptions"
                        [nestedDocOptions]="docViewNestedColumnOptions"
                        [discOptions]="discViewColumnOptions"
                        (docOptionsChanged)="updateColumnDisplay($event)"
                        (disccOptionsChanged)="updateDiscColumnDisplay($event)"
                        (nestedDocOptionsChanged)="
                            updateNestedColumnDisplay($event)
                        "
                        (tableViewChanged)="onTableViewChanged($event)" />
                    <app-text-button
                        [dataQa]="dataQa.stationInboxResetFiltersButton"
                        [disabled]="isResetFiltersDisabled()"
                        (clicked)="resetFilters()">
                        Reset filters
                    </app-text-button>
                </div>
            </div>
        </div>
        @if (!inboxChoicesLoading) {
            <div>
                @switch (selectedTableView) {
                    @case (TableView.Document) {
                        <app-station-document-view
                            [inboxTab]="selectedInboxTab"
                            [workflowId]="selectedWorkflow"
                            (customColumnsChange)="
                                onDocumentCustomColumnsChange($event)
                            " />
                    }
                    @case (TableView.Discrepancy) {
                        <app-station-discrepancy-view
                            [inboxTab]="selectedInboxTab"
                            [workflowId]="selectedWorkflow"
                            (customColumnsChange)="
                                onDiscrepancyCustomColumnsChange($event)
                            " />
                    }
                }
            </div>
        }
    }
}

<ng-template #countTemplate>
    @if (countInformation) {
        <div class="flex items-center mt-1 mb-1 color-gray18 text-s">
            @if (selectedTableView === TableView.Document) {
                {{ countInformation.documentCount }} Documents •
            }
            {{ countInformation.discrepancyCount }} Discrepancies
            <app-tooltip>
                <mat-icon svgIcon="info" trigger />
                <div content class="flex gap-10">
                    <span>{{ countInformation.rejectedCount }} Rejected</span>
                    <mat-divider vertical="true" />
                    <span>
                        {{ countInformation.escalatedCount }} Escalated
                    </span>
                    <mat-divider vertical="true" />
                    <span>
                        {{ countInformation.renotificationCount }}
                        Re-Notification
                    </span>
                </div>
            </app-tooltip>
        </div>
    }
</ng-template>
